import { render, staticRenderFns } from "./PccManual.vue?vue&type=template&id=462ca5b1&scoped=true&"
import script from "./PccManual.vue?vue&type=script&lang=js&"
export * from "./PccManual.vue?vue&type=script&lang=js&"
import style0 from "./PccManual.vue?vue&type=style&index=0&id=462ca5b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462ca5b1",
  null
  
)

export default component.exports